import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./styles.css";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  p: 1,
  outline: 0,
  height: "90vh",
  width: "90vw",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden", // prevent modal scrolling
};

const FileModal = ({ open, onClose, fileUrl, fileType }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <IconButton onClick={onClose} className="file-modal-close-btn">
          <CloseIcon />
        </IconButton>
        <div className="fileModalContainer">
          {fileType === "image/png" ||
          fileType === "image/jpg" ||
          fileType === "image/jpeg" ? (
            <img
              src={fileUrl}
              alt="preview"
              className="fileModal-image-container"
            />
          ) : (
            <Box sx={{ flex: 1, overflow: "auto" /* scroll only PDF area */ }}>
              <iframe
                src={fileUrl}
                title="PDF Preview"
                style={{ border: 0, width: "100%", height: "100%" }}
              />
            </Box>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default FileModal;
